/**
 * Dev-shell specific offline package readers.
 *
 * Reads from a local package:
 * - courseware TOC structure (`toc.json`)
 * - theme variants (`ambrosia.js`)
 *
 * Notes:
 * - This utility is intentionally adapter-only and should not be used by generic runtime code.
 * - `ambrosia.js` is a JS payload with an assignment prefix (`ambrosia = ...`).
 */

import { CoursewareStructure } from "@bronte/viewer/src/data/types";

export const getCoursewareStructure = async (packagePath: string): Promise<CoursewareStructure> => {
  const tocPath = packagePath + `/toc.json`;
  const response = await fetch(tocPath);

  if (!response.ok) {
    throw new Error(`toc.json not found in the package at "${tocPath}"`);
  }

  return (await response.json()) as CoursewareStructure;
};

export const getThemeVariants = async (packagePath: string) => {
  const ambrosiaPath = packagePath + `/ambrosia.js`;
  const data = await fetch(ambrosiaPath);

  const prefix = "ambrosia = ";
  const dataString = (await data.text()).substring(prefix.length);
  const dataJson = JSON.parse(dataString);

  const themeVariants = dataJson?.selectedThemePayload?.themeVariants;
  if (!themeVariants) {
    throw new Error("Could not found themeVariants in the ambrosia.js");
  }

  return themeVariants;
};
